import { render } from "./DashboardPage.vue?vue&type=template&id=fe0b384e&ts=true"
import script from "./DashboardPage.vue?vue&type=script&lang=ts"
export * from "./DashboardPage.vue?vue&type=script&lang=ts"

import "./DashboardPage.vue?vue&type=style&index=0&id=fe0b384e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__